import React from 'react';
import SEO from '@/components/SEO';
import About from '../components/About';
import WhyChooseUs from '../components/WhyChooseUs';

const AboutPage = () => {
  return (
    <>
      <SEO
        title="About Us - AssetWise Business Consultants"
        description="Meet Meena R Kakade and Neeraj R Kakade. With 40+ years in banking and 100 years cumulative expertise, we provide trusted financial solutions."
        path="/about"
        keywords="AssetWise founders, Meena Kakade, Neeraj Kakade, banking experts Mira Road"
      />
      
      <div className="pt-20">
        <About />
        <WhyChooseUs />
      </div>
    </>
  );
};

export default AboutPage;
